'use strict';

const $ = require('dibs-jquery-shim');
const pageTypeHelper = require('../pageTypeHelper');
const {PAGE_TYPE} = require('../../constants/pageTypes');
const calloutHelper = require('../../../components/Callout/calloutHelper');
const calloutActions = require('../../../components/Callout/calloutActions');

/**
 * Checks condition for folder icon callout.
 * Opens callout if condition is satisfied.
 *
 * @return {Promise}
 */
const saveToFolderCalloutRule = function saveToFolderCalloutRule({context}) {
    const type = calloutHelper.CALLOUT_TYPE_SAVE_TO_FOLDER;
    const canShowCallout = calloutHelper.canShowCallout({type});
    const wrap = function (element) {
        if (element) {
            element = element.wrap('<div>').parent();
        }
        return element;
    };

    if (!canShowCallout) {
        return Promise.resolve();
    } else if (pageTypeHelper.isPageType(PAGE_TYPE.PDP)) {
        context.executeAction(calloutActions.openCallout, { type });
        return Promise.resolve({success: true, type});
    }

    const tooltipElement = $('#productsResults').children().first().find('.js-folder-icon');
    calloutHelper.showSaveToFolderCallout({context, tooltipElement: wrap(tooltipElement)});

    return Promise.resolve({success: true, type});
};

module.exports = saveToFolderCalloutRule;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/saveToFolderCalloutRule.es.js